import { Flex, theme } from 'antd';

import useHirePortContext from '@/hooks/useHirePortContext';
import { usePagePadding } from '@/hooks/usePagePadding';

import Header from './Header';

import type React from 'react';

interface PageWrapperProps extends React.ComponentProps<typeof Flex> {
  title?: string;
  subtitle?: React.ReactNode;
  headerChildren?: React.ReactNode;
  headerClassName?: string;
}

const PageWrapper = ({
  children,
  title,
  subtitle,
  headerChildren,
  headerClassName,
  style,
  ...flexProps
}: PageWrapperProps) => {
  const { renderPageWrapper, renderPageHeader } = useHirePortContext();
  const { token } = theme.useToken();
  const padding = usePagePadding();

  const pageHeader =
    title != null ? (
      <Header title={title} subtitle={subtitle} className={headerClassName}>
        {headerChildren}
      </Header>
    ) : null;

  return (
    <Flex
      vertical
      {...flexProps}
      style={{
        ...(renderPageWrapper
          ? {
              backgroundColor: token.colorBgLayout,
            }
          : {}),
        paddingInline: padding.paddingInline,
        /* Header supplies its own top spacing; keep bottom breathing room. */
        paddingBlock: `${renderPageHeader ? 0 : padding.paddingBlock}px ${padding.paddingBlock}px`,
        width: '100%',
        marginInline: 'auto',
        ...style,
      }}
    >
      {renderPageWrapper ? (
        <>
          {pageHeader}
          {children}
        </>
      ) : (
        children
      )}
    </Flex>
  );
};

export default PageWrapper;
